// extracted by mini-css-extract-plugin
export const container = "testimonial-module--container--1bEds";
export const padding = "testimonial-module--padding--11339";
export const cardContainer = "testimonial-module--cardContainer--3TvfS";
export const buttons = "testimonial-module--buttons--ZmMFk";